import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody, IconButton, Icon, AppBar, Toolbar, Typography, Tooltip, Button } from '@material-ui/core';
import * as Actions from './../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

const styles = theme => ({
    root: {}
});

class FailedEventsWidget extends Component {
    componentWillMount = () => {
        const auth_id = this.props.auth.user.data.auth_id;
        this.props.getFailedEvents(auth_id)
    }

    // handleRowClick = (event_id) => {
    //     this.props.history.push(`/grade/student/list/${event_id}`);
    // }

    render() {
        const { failedEventsList, classes } = this.props;

        if (failedEventsList.length === 0) {
            return (
                <React.Fragment>
                    <AppBar position="static">
                        <Toolbar>
                            <Typography variant="h6" color="inherit">
                                No Failed Events!
                        </Typography>
                        </Toolbar>
                    </AppBar>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">
                            Failed Events
                        </Typography>
                    </Toolbar>
                </AppBar>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Student Name</TableCell>
                            <TableCell>Course</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {failedEventsList.map(event => {
                            const eventInfo =
                                <div>
                                    <p>Event Name: {event.EventName}</p>
                                    <p>Event Type: {event.EventType}</p>
                                    <p>Submission Date: {moment(event.EventSubmissionDate).format('YYYY-MM-DD')}</p>
                                    <p>Score / Min: {event.EventScore + ' / ' + event.EventMinScore}</p>
                                </div>
                            return (
                                <TableRow key={event.company_calendar_event_id + '_' + event.auth_id}>
                                    <TableCell>{event.AuthName}</TableCell>
                                    <TableCell>{event.CourseName}</TableCell>
                                    <TableCell>
                                        <Tooltip
                                            title={eventInfo}
                                            enterDelay={100}
                                        >
                                            <div className="flex items-center">
                                                <Icon>info</Icon>
                                            </div>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip
                                            title={eventInfo}
                                            enterDelay={100}
                                        >
                                            <div className="flex items-center">
                                                <Button
                                                    onClick={() => this.props.handleRetakeApprove(event)}
                                                    variant={'contained'}
                                                >
                                                    Approve Retake
                                                </Button>
                                            </div>
                                        </Tooltip>

                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getFailedEvents: Actions.getFailedEvents,
        handleRetakeApprove: Actions.retakeApprove
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth }) {
    return {
        auth: auth,
        failedEventsList: dashboardApp.widgets.failedEventsList
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(FailedEventsWidget)));




// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/FailedEventsWidget.js